<div class="pickup-window" data-testid="pickup-window-section">
  <div class="pickup-window__heading">
    <puro-typography variant="h5-semibold" component="h3" class="pickup-window__title">
      {{ 'createShipment.serviceStep.pickupDropOff.windowTitle' | translate }}
    </puro-typography>
    <p class="pickup-window__helper">
      {{ 'createShipment.serviceStep.pickupDropOff.windowHelper' | translate }}
    </p>
  </div>

  @if (windowNotice()) {
    <puro-alert severity="warning" data-testid="pickup-window-notice">{{
      windowNotice()
    }}</puro-alert>
  }

  <fieldset
    class="pickup-window__times"
    [attr.aria-label]="'createShipment.serviceStep.pickupDropOff.windowTitle' | translate"
  >
    <div class="pickup-window__select">
      <app-floating-select
        [label]="'createShipment.serviceStep.pickupDropOff.windowFromLabel' | translate"
        [options]="asSelectOptions(fromOptions())"
        [fullWidth]="true"
        [ngModel]="windowFrom()"
        (ngModelChange)="onFromChange($event)"
        data-testid="pickup-window-from"
      />
    </div>

    <span class="pickup-window__to" aria-hidden="true">
      {{ 'createShipment.serviceStep.pickupDropOff.windowTo' | translate }}
    </span>

    <div class="pickup-window__select">
      <app-floating-select
        [label]="'createShipment.serviceStep.pickupDropOff.windowUntilLabel' | translate"
        [options]="asSelectOptions(toOptions())"
        [fullWidth]="true"
        [ngModel]="windowTo()"
        (ngModelChange)="onToChange($event)"
        data-testid="pickup-window-to"
      />
    </div>
  </fieldset>

  <p class="pickup-window__note">
    {{ 'createShipment.serviceStep.pickupDropOff.windowNote' | translate }}
  </p>
</div>
